import React from 'react'

const AboutBannerSection = () => {
    return (
        <>
            <section className="bannerSec innerBanner">
                <div className="box-position" style={{background: 'url("images/innerBanner.jpg")'}}>

                </div>
                <div className="bannerTxt">
                    <h1>About</h1>
                </div>
            </section>
        </>
    )
}

export default AboutBannerSection